import { Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import LogItem from './LogItem';
import { VersionData } from 'types/lcms/courses';

interface LogHistoryProps {
  data?: VersionData[];
}

const LogHistory: React.FC<LogHistoryProps> = ({ data }) => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Text c={'dark'} fw={700}>
            Log History
          </Text>
        </Group>
        {data?.length === 0 && (
          <Text c={'secondary'} fz={'sm'}>
            No log history found
          </Text>
        )}
        {data && data?.length > 0 && (
          <Stack gap={16}>
            {data.map((item, index) => (
              <LogItem key={index} {...item} />
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default LogHistory;
